import { createSlice } from '@reduxjs/toolkit';
import { getEmailTemplates } from 'api/email-templates';
import { dispatch } from '../index';

const initialState = {
    list: [],
    total: 0,
    isLoading: false
};

const slice = createSlice({
    name: 'emailTemplates',
    initialState,
    reducers: {
        setEmailTemplatesList(state, action) {
            state.list = action.payload;
            state.isLoading = false;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        }
    }
});

export default slice.reducer;

export function initialLoadEmailTemplates() {
    return async () => {
        await getListEmailTemplates();
    };
}

async function getListEmailTemplates() {
    try {
        dispatch(slice.actions.setLoading(true));
        const emailTemplates = await getEmailTemplates();
        dispatch(slice.actions.setEmailTemplatesList(emailTemplates?.data));
    } catch (err) {
        console.log(err);
        dispatch(slice.actions.setLoading(false));
        throw new Error(err.message);
    }
}
